export default {
  "金融风控": [{
    "index": 1,
    "name": "own",
    "chineseName": "所有者（公司/组织）",
    "metric": "记录该机器行为或账户的所有者信息，通常是企业名称或组织名称",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 2,
    "name": "affiliation_opr_line",
    "chineseName": "所属运营商/线路",
    "metric": "指明该机器或账户所使用的通信运营商及其提供的线路信息。",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 3,
    "name": "whether_idc",
    "chineseName": "是否IDC",
    "metric": "标识该机器是否位于互联网数据中心（IDC）",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 4,
    "name": "whether_base_sta",
    "chineseName": "是否基站",
    "metric": "标识该机器是否作为基站使用",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 5,
    "name": "whether_vpn",
    "chineseName": "是否VPN",
    "metric": "表明该机器是否通过虚拟私人网络（VPN）进行通信",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 6,
    "name": "whether_for_inter_num",
    "chineseName": "是否为中介号码",
    "metric": "判断该号码是否作为中介服务使用",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 7,
    "name": "black_itmd_type",
    "chineseName": "黑中介类型",
    "metric": "如果标记为中介号码，则进一步细分其类型，如诈骗中介、营销中介等",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 8,
    "name": "inter_call_num",
    "chineseName": "中介呼入的次数",
    "metric": "统计中介号码呼入该机器或账户的次数",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 9,
    "name": "inter_call_cum_dur",
    "chineseName": "中介呼入累计时长（秒）",
    "metric": "统计中介号码呼入该机器或账户的总时长",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 10,
    "name": "call_inter_num",
    "chineseName": "呼出到中介的次数",
    "metric": "统计该机器或账户呼出到中介号码的次数",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 11,
    "name": "call_inter_cum_dur",
    "chineseName": "呼出到中介累计时长（秒）",
    "metric": "统计该机器或账户呼出到中介号码的总时长",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 12,
    "name": "mail_list_cntn_inter_num",
    "chineseName": "通讯录包含中介的个 数",
    "metric": "统计该机器或账户通讯录中中介号码的数量",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 13,
    "name": "recent_1_y_mly_stat_abv_fld",
    "chineseName": "最近一年逐月统计以上字段",
    "metric": "对以上与中介相关的字段进行月度统计",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 14,
    "name": "yellow_pages_info",
    "chineseName": "黄页信息",
    "metric": "该机器或账户关联的公开信息，如企业黄页中的记录",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 15,
    "name": "hit_ind_flw_nam_list_rule_id_list",
    "chineseName": "命中的行业关注名单规则 ID 列表",
    "metric": "根据特定的行业规则或黑名单，判断该机器或账户是否涉及风险行为，并列出具体的规则ID",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 16,
    "name": "whether_hit_ind_flw_nam_list",
    "chineseName": "是否命中行业关注名单",
    "metric": "根据特定的行业规则或黑名单，判断该机器或账户是否涉及风险行为",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 17,
    "name": "ovd_bhvr",
    "chineseName": "逾期行为",
    "metric": "包括多种贷款类型的逾期情况，如现金贷、消费贷等，记录逾期状态及详情",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 18,
    "name": "cash_loan",
    "chineseName": "现金贷 ",
    "metric": "现金贷逾期情况",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 19,
    "name": "cnsm_loan",
    "chineseName": "消费贷 ",
    "metric": "消费贷逾期情况",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 20,
    "name": "small_amt_short_term_loan",
    "chineseName": "小额短期贷 ",
    "metric": "小额短期贷逾期情况",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 21,
    "name": "pop_pltf_loan",
    "chineseName": "流行平台贷款 ",
    "metric": "流行平台贷款逾期情况",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 22,
    "name": "crdt_card_compst_staging",
    "chineseName": "信用卡代偿分期 ",
    "metric": "信用卡代偿分期逾期情况",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 23,
    "name": "asst_loan",
    "chineseName": "助学贷款 ",
    "metric": "助学贷款逾期情况",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 24,
    "name": "no_bank_oth",
    "chineseName": "非银行其他 ",
    "metric": "非银行其他逾期情况",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 25,
    "name": "hous_loan",
    "chineseName": "房贷 ",
    "metric": "房贷逾期情况",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 26,
    "name": "vhcl_loan",
    "chineseName": "汽车贷款 ",
    "metric": "汽车贷款逾期情况",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 27,
    "name": "onln_loan_total_cnt",
    "chineseName": "网贷总计 ",
    "metric": "统计该机器或账户涉及的网贷总额",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 28,
    "name": "pltf_cnt",
    "chineseName": "平台数",
    "metric": "统计该机器或账户涉及的贷款平台数量",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 29,
    "name": "max_ovd_dur",
    "chineseName": "最大逾期时长",
    "metric": "记录最长的逾期时间",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 30,
    "name": "recent_6_m_each_trans_cnsm_mean_val",
    "chineseName": "最近6个月每笔消费均值",
    "metric": "最近6个月内该机器或账户的消费总金额/总次数",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 31,
    "name": "recent_6_m_every_d_cnsm_mean_val",
    "chineseName": "最近6个月每天消费均值",
    "metric": "最近6个月内该机器或账户的消费总金额/总天数",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 32,
    "name": "recent_6_m_every_d_cnsm_avg_trans_num",
    "chineseName": "最近6个月每天消费平均笔数",
    "metric": "最近6个月内该机器或账户的消费总比数/总天数",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 33,
    "name": "recent_6_m_cnsm_ds",
    "chineseName": "最近6个月有消费的天数",
    "metric": "统计最近6个月内，有消费记录的天数",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 34,
    "name": "recent_6_m_amt_grtr_than_5_cnsm_mean_val",
    "chineseName": "最近6个月数额大于5的消费均值",
    "metric": "计算最近6个月内，所有消费额大于5元的消费的平均金额",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 35,
    "name": "recent_6_m_amt_grtr_than_5_cnsm_trans_num",
    "chineseName": "最近6个月数额大于5的消费笔数",
    "metric": "统计最近6个月内，消费额大于5元的消费笔数",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 36,
    "name": "recent_6_m_cnsm_max_cnsm_amt",
    "chineseName": "最近6个月消费最大的消费额",
    "metric": "记录最近6个月内，单笔最大的消费金额",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 37,
    "name": "recent_6_m_mly_cnsm_mean_val",
    "chineseName": "最近6个月每月消费均值",
    "metric": "最近6个月内该机器或账户的消费总金额/总月份数",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 38,
    "name": "recent_6_m_mly_cnsm_avg_trans_num",
    "chineseName": "最近6个月每月消费平均笔数",
    "metric": "最近6个月内该机器或账户的消费总笔数/总月份数",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 39,
    "name": "recent_6_m_cnsm_total_trans_num",
    "chineseName": "最近6个月消费总笔数",
    "metric": "统计最近6个月内，总的消费笔数",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 40,
    "name": "recent_6_m_wkly_cnsm_mean_val",
    "chineseName": "最近6个月每周消费均值",
    "metric": "最近6个月内该机器或账户的消费总金额/总周数",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 41,
    "name": "recent_6_m_wkly_cnsm_avg_trans_num",
    "chineseName": "最近6个月每周消费平均笔数",
    "metric": "最近6个月内该机器或账户的消费总笔数/总周数",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 42,
    "name": "debit_card_num",
    "chineseName": "借记卡个数",
    "metric": "统计该机器或账户关联的借记卡数量",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 43,
    "name": "recent_6_m_min_salary_amt",
    "chineseName": "最近6个月最小的工资额",
    "metric": "记录最近6个月内，最低的工资金额",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 44,
    "name": "recent_6_m_max_salary_amt",
    "chineseName": "最近6个月最大的工资额",
    "metric": "记录最近6个月内，最高的工资金额",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 45,
    "name": "recent_6_m_income_mean_val",
    "chineseName": "最近6个月收入均值",
    "metric": "最近6个月总收入/总月份数",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 46,
    "name": "recent_6_m_income_max",
    "chineseName": "最近6个月收入最大值",
    "metric": "记录最近6个月内，收入的最大值",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 47,
    "name": "recent_6_m_income_trans_num",
    "chineseName": "最近6个月收入笔数",
    "metric": "统计最近6个月内，收入的总笔数",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 48,
    "name": "recent_6_m_have_fina_cnsm_acty_m",
    "chineseName": "最近6个月有金融/消费活动的月数",
    "metric": "统计最近6个月内，有金融或消费活动的月份数量",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 49,
    "name": "recent_6_m_have_repay_m",
    "chineseName": "最近6个月有还款的月数",
    "metric": "统计最近6个月内，有还款记录的月份数量",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 50,
    "name": "recent_6_m_have_salary_m",
    "chineseName": "最近6个月有工资的月数",
    "metric": "统计最近6个月内，有工资记录的月份数量",
    "frequency": "月",
    "range": "全国"
  }],
  "OTA数据": [{
    "index": 1,
    "name": "rcpt_tur_psgr_flow",
    "chineseName": "接待游客客流量",
    "metric": "统计某一时间段内到访某地区或景区的游客总数",
    "frequency": "天",
    "range": "全国"
  }, {
    "index": 2,
    "name": "each_distr_tur_rcpt_cnt",
    "chineseName": "各区/县游客接待量",
    "metric": "分别统计各个区或县在指定时间段内的游客接待数量",
    "frequency": "天",
    "range": "全国"
  }, {
    "index": 3,
    "name": "each_busi_prsn_time_ratio",
    "chineseName": "各业务人次占比",
    "metric": "指景区内不同业务（如观光、住宿、餐饮、购物等）的游客参与人次占总游客人次的比例",
    "frequency": "天",
    "range": "全国"
  }, {
    "index": 4,
    "name": "each_prov_and_city_tur_rcpt_cnt",
    "chineseName": "各市/州游客接待量",
    "metric": "按行政区划（市、州）统计的游客接待数量，",
    "frequency": "天",
    "range": "全国"
  }, {
    "index": 5,
    "name": "cnsm_total_amt",
    "chineseName": "消费总金额",
    "metric": "统计游客在旅游过程中的总消费金额",
    "frequency": "天",
    "range": "全国"
  }, {
    "index": 6,
    "name": "each_type_cnsm_amt_ratio",
    "chineseName": "各类型消费金额占比",
    "metric": "分析不同类型消费（如住宿、餐饮、购物等）在总消费金额中的占比",
    "frequency": "天",
    "range": "全国"
  }, {
    "index": 7,
    "name": "each_busi_per_capita_cnsm_amt",
    "chineseName": "各业务人均消费金额",
    "metric": "计算各业务（如住宿、餐饮等）的人均消费金额，即：该业务总消费金额/参与该业务的游客人数",
    "frequency": "天",
    "range": "全国"
  }, {
    "index": 8,
    "name": "each_distr_per_capita_cnsm_amt",
    "chineseName": "各区县人均消费金额",
    "metric": "统计各区县游客的人均消费金额，即：该区县内总消费金额/该曲线的游客人数",
    "frequency": "天",
    "range": "全国"
  }, {
    "index": 9,
    "name": "each_gndr_avg_cnsm_amt",
    "chineseName": "各性别平均消费金额",
    "metric": "分别统计男性和女性游客的平均消费金额，即：男（女）性总消费金额/男（女）性游客人数",
    "frequency": "天",
    "range": "全国"
  }, {
    "index": 10,
    "name": "each_y_tur_avg_cnsm_amt",
    "chineseName": "各年代游客平均消费金额",
    "metric": "按出生年代（如70后、80后、90后等）划分的游客群体，计算其平均消费金额，即：该年代人群总消费金额/该年代游客人数",
    "frequency": "天",
    "range": "全国"
  }, {
    "index": 11,
    "name": "each_age_seg_tur_avg_cnsm_amt",
    "chineseName": "各年段游客平均消费金额",
    "metric": "按年龄段（如儿童、青年、中年、老年）划分的游客群体，计算其平均消费金额，即：该年龄段人群总消费金额/该年龄段游客人数",
    "frequency": "天",
    "range": "全国"
  }, {
    "index": 12,
    "name": "pop_cust_src_city_per_capita_cnsm_amt",
    "chineseName": "热门客源市人均消费金额",
    "metric": "统计来自特定热门客源城市的游客的人均消费金额，即：该客源市人群总消费金额/该客源市游客人数",
    "frequency": "天",
    "range": "全国"
  }, {
    "index": 13,
    "name": "per_capita_cnsm_top10_cust_src_prov",
    "chineseName": "人均消费top10客源省",
    "metric": "人均消费最高的前10个客源省份",
    "frequency": "天",
    "range": "全国"
  }, {
    "index": 14,
    "name": "hk_mac_tw_tur_per_capita_cnsm_amt",
    "chineseName": "港澳台游客人均消费金额",
    "metric": "统计来自港澳台地区的游客的人均消费金额",
    "frequency": "天",
    "range": "全国"
  }, {
    "index": 15,
    "name": "per_capita_cnsm_price_sec_dist",
    "chineseName": "人均消费价格区间分布",
    "metric": "游客人均消费金额在不同价格区间的分布情况",
    "frequency": "天",
    "range": "全国"
  }, {
    "index": 16,
    "name": "diff_gndr_tur_per_capita_cnsm_price_sec_dist",
    "chineseName": "不同性别游客人均消费价格区间分布",
    "metric": "按性别分析人均消费金额在不同价格区间的分布情况",
    "frequency": "天",
    "range": "全国"
  }, {
    "index": 17,
    "name": "each_y_tur_avg_cnsm_price_sec_dist",
    "chineseName": "各年代游客平均消费价格区间分布",
    "metric": "按出生年代分析人均消费金额在不同价格区间的分布情况",
    "frequency": "天",
    "range": "全国"
  }, {
    "index": 18,
    "name": "each_age_seg_trav_cnsm_price_sec_dist",
    "chineseName": "各年龄段出游消费价格区间分布",
    "metric": "按年龄段（如儿童、青年、中年、老年）分析人均消费金额在不同价格区间的分布情况",
    "frequency": "天",
    "range": "全国"
  }, {
    "index": 19,
    "name": "each_cust_src_city_per_capita_cnsm_price_sec_dist",
    "chineseName": "各客源市人均消费价格区间分布",
    "metric": "按客源市分析人均消费金额在不同价格区间的分布情况",
    "frequency": "天",
    "range": "全国"
  }, {
    "index": 20,
    "name": "on_vacation_prod_per_capita_cnsm_price_sec_dist",
    "chineseName": "度假产品人均消费价格区间分布",
    "metric": "按度假产品分析人均消费金额在不同价格区间的分布情况",
    "frequency": "天",
    "range": "全国"
  }, {
    "index": 21,
    "name": "cust_src_hk_mac_tw_price_sec_dist",
    "chineseName": "客源港澳台价格区间分布",
    "metric": "按港澳台客源分析人均消费金额在不同价格区间的分布情况",
    "frequency": "天",
    "range": "全国"
  }, {
    "index": 22,
    "name": "pop_cust_src_city_dom_prsn_time_dist",
    "chineseName": "热门客源城市（国内）人次分布",
    "metric": "统计热门客源城市的人次分布情况",
    "frequency": "天",
    "range": "全国"
  }, {
    "index": 23,
    "name": "pop_cust_src_prov_prsn_time_dist",
    "chineseName": "热门客源省人次分布",
    "metric": "统计热门客源省份的人次分布情况",
    "frequency": "天",
    "range": "全国"
  }, {
    "index": 24,
    "name": "pop_cust_src_cntry_prsn_time_dist",
    "chineseName": "热门客源国家人次分布",
    "metric": "统计热门客源国家的人次分布情况",
    "frequency": "天",
    "range": "全国"
  }, {
    "index": 25,
    "name": "cnsm_amt_top20_cust_src_prov_and_amt_ratio",
    "chineseName": "消费金额top20客源省及金额占比",
    "metric": "消费金额最高的前20个客源省份及其消费金额占总消费金额的比例",
    "frequency": "天",
    "range": "全国"
  }, {
    "index": 26,
    "name": "dom_and_fgn_prsn_time_dist",
    "chineseName": "境内外人次分布",
    "metric": "统计境内和境外游客的人次分布情况",
    "frequency": "天",
    "range": "全国"
  }, {
    "index": 27,
    "name": "hk_mac_tw_and_ovsea_tur_prsn_time_dist",
    "chineseName": "港澳台及海外游客人次分布",
    "metric": "统计港澳台地区和海外游客的人次分布情况",
    "frequency": "天",
    "range": "全国"
  }, {
    "index": 28,
    "name": "cust_src_hk_mac_tw_prsn_time_dist",
    "chineseName": "客源港澳台人次分布",
    "metric": "统计港澳台地区客源的人次分布情况",
    "frequency": "天",
    "range": "全国"
  }, {
    "index": 29,
    "name": "advc_book_ds_dist",
    "chineseName": "提前预订天数分布",
    "metric": "统计游客提前预订的天数分布情况",
    "frequency": "天",
    "range": "全国"
  }, {
    "index": 30,
    "name": "resi_time_dist",
    "chineseName": "停留时间分布",
    "metric": "统计游客在目的地的停留时间分布情况",
    "frequency": "天",
    "range": "全国"
  }, {
    "index": 31,
    "name": "each_busi_advc_res_ds_dist",
    "chineseName": "各业务提前预定天数分布",
    "metric": "分别统计不同业务（如住宿、门票等）的提前预订天数分布情况",
    "frequency": "天",
    "range": "全国"
  }, {
    "index": 32,
    "name": "plc_ord_time_dist",
    "chineseName": "下单时间分布",
    "metric": "统计游客下单预订的时间分布情况",
    "frequency": "天",
    "range": "全国"
  }, {
    "index": 33,
    "name": "tur_trav_intent_dist",
    "chineseName": "游客出行意图分布",
    "metric": "统计游客出行的主要意图或目的分布情况",
    "frequency": "天",
    "range": "全国"
  }, {
    "index": 34,
    "name": "diff_term_book_ratio",
    "chineseName": "不同终端预订占比",
    "metric": "统计通过手机、电脑等不同终端进行预订的游客占比",
    "frequency": "天",
    "range": "全国"
  }, {
    "index": 35,
    "name": "whl_tur_each_y_prsn_time_dist",
    "chineseName": "整体游客各年代人次分布",
    "metric": "按出生年代（如70后、80后、90后等）分类统计游客人次分布情况",
    "frequency": "天",
    "range": "全国"
  }, {
    "index": 36,
    "name": "each_age_seg_tur_prsn_time_dist",
    "chineseName": "各年龄段游客人次分布",
    "metric": "按年龄段（如儿童、青年、中年、老年）分类统计游客人次分布情况",
    "frequency": "天",
    "range": "全国"
  }, {
    "index": 37,
    "name": "dom_tur_each_age_seg_prsn_time_dist",
    "chineseName": "国内游客各年龄段人次分布",
    "metric": "按国内的游客年龄段（如儿童、青年、中年、老年）分类统计游客人次分布情况",
    "frequency": "天",
    "range": "全国"
  }, {
    "index": 38,
    "name": "abroad_tur_each_age_seg_prsn_time_dist",
    "chineseName": "境外游客各年龄段人次分布",
    "metric": "按境外的游客年龄段（如儿童、青年、中年、老年）分类统计游客人次分布情况",
    "frequency": "天",
    "range": "全国"
  }, {
    "index": 39,
    "name": "pop_cust_src_city_diff_age_seg_prsn_time_dist",
    "chineseName": "热门客源市不同年龄段人次分布",
    "metric": "按特定热门客源城市统计游客年龄段（如儿童、青年、中年、老年）人次分布情况",
    "frequency": "天",
    "range": "全国"
  }, {
    "index": 40,
    "name": "pop_cust_src_prov_diff_age_seg_prsn_time_dist",
    "chineseName": "热门客源省不同年龄段人次分布",
    "metric": "按特定热门客源省份统计游客年龄段（如儿童、青年、中年、老年）人次分布情况",
    "frequency": "天",
    "range": "全国"
  }, {
    "index": 41,
    "name": "whl_tur_each_gndr_prsn_time_dist",
    "chineseName": "整体游客各性别人次分布",
    "metric": "按性别统计游客的人次分布情况",
    "frequency": "天",
    "range": "全国"
  }, {
    "index": 42,
    "name": "dom_tur_each_gndr_prsn_time_dist",
    "chineseName": "国内游客各性别人次分布",
    "metric": "按性别统计国内游客的人次分布情况",
    "frequency": "天",
    "range": "全国"
  }, {
    "index": 43,
    "name": "abroad_tur_each_gndr_prsn_time_dist",
    "chineseName": "境外游客各性别人次分布",
    "metric": "按性别统计境外游客的人次分布情况",
    "frequency": "天",
    "range": "全国"
  }, {
    "index": 44,
    "name": "pop_cust_src_city_each_gndr_prsn_time_dist",
    "chineseName": "热门客源市各性别人次分布",
    "metric": "按性别统计热门客源城市的人次分布情况",
    "frequency": "天",
    "range": "全国"
  }, {
    "index": 45,
    "name": "pop_cust_src_prov_each_gndr_prsn_time_dist",
    "chineseName": "热门客源省各性别人次分布",
    "metric": "按性别统计热门客源省份的人次分布情况",
    "frequency": "天",
    "range": "全国"
  }, {
    "index": 46,
    "name": "each_tfc_meth_prsn_time_dist",
    "chineseName": "各交通方式人次分布",
    "metric": "统计游客选择不同交通方式（如飞机、火车、汽车等）到达目的地的人次",
    "frequency": "天",
    "range": "全国"
  }, {
    "index": 47,
    "name": "sta_prsn_time_ratio",
    "chineseName": "场站人次占比",
    "metric": "统计不同交通枢纽（如机场、火车站等）的游客流量占比",
    "frequency": "天",
    "range": "全国"
  }, {
    "index": 48,
    "name": "plane_ticket_tour_src_rank",
    "chineseName": "机票客源地排名",
    "metric": "统计机票的客源地排名",
    "frequency": "天",
    "range": "全国"
  }, {
    "index": 49,
    "name": "in_and_out_ports_psgr_flow",
    "chineseName": "进出港客流量",
    "metric": "统计港口的进出港客流量情况",
    "frequency": "天",
    "range": "全国"
  }, {
    "index": 50,
    "name": "use_car_tour_src_rank",
    "chineseName": "用车客源地排名",
    "metric": "统计用车服务的客源地排名",
    "frequency": "天",
    "range": "全国"
  }],
  "房地产数据": [{
    "index": 1,
    "name": "price",
    "chineseName": "价格",
    "metric": "房屋的售价或成交价格",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 2,
    "name": "prov",
    "chineseName": "省份",
    "metric": "房屋所在的具体省份",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 3,
    "name": "city",
    "chineseName": "城市",
    "metric": "房屋所在的具体城市或地区",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 4,
    "name": "region_peri",
    "chineseName": "区域/周边",
    "metric": "房屋所在的城市内的具体区域或周边环境描述",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 5,
    "name": "street",
    "chineseName": "街道",
    "metric": "房屋所在的详细街道名称",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 6,
    "name": "trans_ownersh",
    "chineseName": "交易权属",
    "metric": "房屋的产权性质，如商品房、房改房、经济适用房等",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 7,
    "name": "arki_struct",
    "chineseName": "建筑结构",
    "metric": "房屋的建筑结构类型，如钢筋混凝土结构、砖混结构等",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 8,
    "name": "hse_age",
    "chineseName": "房屋年限",
    "metric": "房屋已使用年限",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 9,
    "name": "prop_right_age",
    "chineseName": "产权年限",
    "metric": "房屋产权的法定年限",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 10,
    "name": "arki_area",
    "chineseName": "建筑面积",
    "metric": "房屋的总建筑面积，包括套内面积和公摊面积",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 11,
    "name": "hse_purp",
    "chineseName": "房屋用途",
    "metric": "房屋的使用功能，如住宅、商业、办公等",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 12,
    "name": "ladder_hshd_prop",
    "chineseName": "梯户比例",
    "metric": "电梯数量与楼层户数的比例",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 13,
    "name": "htg_meth",
    "chineseName": "供暖方式",
    "metric": "房屋的供暖系统类型，如集中供暖、自采暖等",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 14,
    "name": "arki_type",
    "chineseName": "建筑类型",
    "metric": "如高层、多层、别墅",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 15,
    "name": "cmplt_y",
    "chineseName": "建成年代",
    "metric": "房屋建设完成并投入使用的年份",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 16,
    "name": "hse_house_mdl",
    "chineseName": "房屋户型",
    "metric": "房屋的房间布局和类型，如两室一厅、三室两厅等",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 17,
    "name": "hse_orien",
    "chineseName": "房屋朝向",
    "metric": "房屋的主要采光和通风面向",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 18,
    "name": "where_flr",
    "chineseName": "所在楼层",
    "metric": "房屋在整栋楼中的具体层数",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 19,
    "name": "lst_time",
    "chineseName": "挂牌时间",
    "metric": "房屋在房地产市场或中介平台上挂牌出售的日期",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 20,
    "name": "house_mdl_struct",
    "chineseName": "户型结构",
    "metric": "房屋各房间的具体布局和功能划分",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 21,
    "name": "inth_area",
    "chineseName": "套内面积",
    "metric": "房屋内部实际可使用的面积，不包括公摊面积",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 22,
    "name": "housing_rights_affiliation",
    "chineseName": "房权所属",
    "metric": "房屋所有权的归属情况，如个人所有、共有等",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 23,
    "name": "num",
    "chineseName": "编号",
    "metric": "用于标识房屋或房源的唯一编号",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 24,
    "name": "reno_itu",
    "chineseName": "装修情况",
    "metric": "房屋的装修程度，如毛坯、简装、精装等",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 25,
    "name": "eqpt_elev",
    "chineseName": "配备电梯",
    "metric": "房屋所在楼宇是否配备电梯",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 26,
    "name": "deal_dt",
    "chineseName": "成交日期",
    "metric": "房屋最终成交的日期",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 27,
    "name": "comm_nam",
    "chineseName": "小区名称",
    "metric": "房屋所在小区的名称",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 28,
    "name": "lst_price",
    "chineseName": "挂牌价格（万）",
    "metric": "房屋在市场上的挂牌价格，单位为万元",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 29,
    "name": "deal_clc",
    "chineseName": "成交周期（天）",
    "metric": "从房屋挂牌到最终成交所需的时间，以天为单位",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 30,
    "name": "prop_right_affiliation",
    "chineseName": "产权所属",
    "metric": "与房权所属类似，强调产权的归属情况",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 31,
    "name": "mortg_info",
    "chineseName": "抵押信息",
    "metric": "房屋是否存在抵押情况及其详细信息",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 32,
    "name": "last_time_trans",
    "chineseName": "上次交易",
    "metric": "房屋上一次交易的时间、价格等相关信息",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 33,
    "name": "comm_introduce",
    "chineseName": "小区介绍",
    "metric": "对小区环境、设施、管理等基本情况的介绍",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 34,
    "name": "suit_crowd",
    "chineseName": "适宜人群",
    "metric": "根据房屋特性和周边环境，适合哪类人群居住或投资",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 35,
    "name": "peri_support_fclt",
    "chineseName": "周边配套",
    "metric": "小区周边的交通、商业、教育、医疗等配套设施情况",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 36,
    "name": "tax_anlys",
    "chineseName": "税费解析",
    "metric": "购买该房屋可能涉及的税费种类和计算方式",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 37,
    "name": "core_sell_point",
    "chineseName": "核心卖点",
    "metric": "房屋的主要优势或吸引点",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 38,
    "name": "tfc_trav",
    "chineseName": "交通出行",
    "metric": "小区周边的交通状况，包括公交、地铁、自驾等出行方式的便利性",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 39,
    "name": "house_mdl_introduce",
    "chineseName": "户型介绍",
    "metric": "对房屋户型的详细解读，包括房间布局、功能分区等",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 40,
    "name": "house_sale_deets",
    "chineseName": "售房详情",
    "metric": "关于房屋销售的详细信息和条件",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 41,
    "name": "reno_desc",
    "chineseName": "装修描述",
    "metric": "对房屋装修风格、材料、品牌等的详细描述",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 42,
    "name": "ownersh_mortg",
    "chineseName": "权属抵押",
    "metric": "与抵押信息类似，强调房屋的权属和抵押状态",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 43,
    "name": "pref_city",
    "chineseName": "地级市",
    "metric": "房屋所在的地级市名称",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 44,
    "name": "hse_total",
    "chineseName": "房屋总数",
    "metric": "小区内房屋的总数量",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 45,
    "name": "comm_addr",
    "chineseName": "小区地址",
    "metric": "小区的具体地理位置和地址",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 46,
    "name": "arki_y",
    "chineseName": "建筑年代",
    "metric": "指小区或楼宇的整体建设年代",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 47,
    "name": "bld_total",
    "chineseName": "楼栋总数",
    "metric": "小区内楼栋的总数量",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 48,
    "name": "prop_fee",
    "chineseName": "物业费用",
    "metric": "小区或楼宇的物业管理费用标准",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 49,
    "name": "devs",
    "chineseName": "开发商",
    "metric": "小区或楼宇的开发建设单位",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 50,
    "name": "prop_comp",
    "chineseName": "物业公司",
    "metric": "负责小区或楼宇物业管理服务的公司",
    "frequency": "月",
    "range": "全国"
  }],
  "互联网数据": [{
    "index": 1,
    "name": "age_rating",
    "chineseName": "年龄分级",
    "metric": "根据应用的内容、功能、适宜人群等因素，对应用进行的年龄划分，如儿童、青少年、成人等",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 2,
    "name": "application_category",
    "chineseName": "应用类别",
    "metric": "应用所属的主要分类，如教育、娱乐、游戏、工具等",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 3,
    "name": "app_unique_code",
    "chineseName": "app唯一代码",
    "metric": "用于唯一标识一个应用的代码",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 4,
    "name": "app_name",
    "chineseName": "app名称",
    "metric": "应用的正式名称",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 5,
    "name": "app_image",
    "chineseName": "app图片",
    "metric": "应用的展示图片",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 6,
    "name": "app_score",
    "chineseName": "app评分",
    "metric": "用户对应用的评分",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 7,
    "name": "app_package_name",
    "chineseName": "app包名",
    "metric": "应用的唯一包名，用于Android（ios）系统中标识应用，通常由开发者在发布时指定",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 8,
    "name": "app_compatibility",
    "chineseName": "app兼容性",
    "metric": "应用支持的设备或系统版本信息，如支持iOS 10.0及以上，Android 4.4及以上等",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 9,
    "name": "app_description",
    "chineseName": "app描述",
    "metric": "对应用功能的详细描述，帮助用户了解应用的主要功能和特点",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 10,
    "name": "app_download_count",
    "chineseName": "app下载量",
    "metric": "应用的累计下载次数",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 11,
    "name": "company_name",
    "chineseName": "企业名称",
    "metric": "应用开发或发布企业的名称",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 12,
    "name": "app_tags",
    "chineseName": "应用标签",
    "metric": "用于描述应用特点或分类的关键词或短语，帮助用户搜索和发现应用",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 13,
    "name": "app_logo",
    "chineseName": "app logo",
    "metric": "应用的标志或图标",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 14,
    "name": "company_unique_code",
    "chineseName": "企业唯一代码",
    "metric": "用于唯一标识应用开发或发布企业的代码",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 15,
    "name": "platform_listing_code",
    "chineseName": "上架平台代码",
    "metric": "应用上架的平台（如App Store、Google Play等）的唯一代码或标识",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 16,
    "name": "number_of_ratings",
    "chineseName": "评分人数",
    "metric": "参与应用评分的用户数量",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 17,
    "name": "release_date",
    "chineseName": "发布时间",
    "metric": "应用首次上架的时间",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 18,
    "name": "app_subtitle",
    "chineseName": "app副标题",
    "metric": "应用的辅助标题或简短描述",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 19,
    "name": "app_support_website",
    "chineseName": "app支持网站",
    "metric": "应用的官方网站或支持页面的链接",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 20,
    "name": "latest_update_content",
    "chineseName": "本次更新内容",
    "metric": "应用最新版本的主要更新内容或修复的问题",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 21,
    "name": "version_number",
    "chineseName": "版本号",
    "metric": "应用的当前版本号",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 22,
    "name": "keywords",
    "chineseName": "关键词",
    "metric": "用于搜索引擎优化（SEO）的关键词",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 23,
    "name": "ranking",
    "chineseName": "排名",
    "metric": "应用在某个平台或分类下的排名位置",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 24,
    "name": "result_count",
    "chineseName": "结果数",
    "metric": "在搜索或查询过程中返回的结果数量",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 25,
    "name": "search_index",
    "chineseName": "搜索指数",
    "metric": "特定关键词或应用在搜索引擎中的搜索频率或热度",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 26,
    "name": "app_ranking_category",
    "chineseName": "app排名的分类",
    "metric": "应用在不同分类下的排名位置",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 27,
    "name": "promotion_title",
    "chineseName": "推广标题",
    "metric": "用于推广活动的应用标题或宣传语",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 28,
    "name": "game_approval_number",
    "chineseName": "游戏批文号",
    "metric": "针对游戏类应用，政府或相关机构颁发的批准文号",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 29,
    "name": "application_classification_-statistics",
    "chineseName": "应用分类-统计",
    "metric": "应用所属分类的统计信息",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 30,
    "name": "app_launch_time",
    "chineseName": "app上架时间",
    "metric": "应用首次上架到某个平台的具体时间",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 31,
    "name": "game_copyright_holder",
    "chineseName": "游戏著作权人",
    "metric": "针对游戏类应用，游戏的著作权人信息",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 32,
    "name": "average_app_score",
    "chineseName": "应用平均评分",
    "metric": "应用在所有评分中的平均值",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 33,
    "name": "android_version_available",
    "chineseName": "是否有安卓版本",
    "metric": "应用是否提供Android系统的版本",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 34,
    "name": "hd_version_available",
    "chineseName": "是否有HD版本",
    "metric": "应用是否提供高清（HD）版本，通常针对平板电脑等大屏设备",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 35,
    "name": "ios_version_available",
    "chineseName": "是否有iOS版本",
    "metric": "应用是否提供iOS系统的版本",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 36,
    "name": "promotion_available",
    "chineseName": "是否有推广",
    "metric": "应用当前是否正在进行推广活动",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 37,
    "name": "watch_version_available",
    "chineseName": "是否有手表版本",
    "metric": "应用是否提供智能手表或可穿戴设备的版本",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 38,
    "name": "apple_track_id",
    "chineseName": "苹果track ID",
    "metric": "针对iOS应用，Apple Store中的唯一跟踪标识符",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 39,
    "name": "game_edition_number",
    "chineseName": "游戏版号",
    "metric": "针对游戏类应用，政府或相关机构颁发的游戏版本号",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 40,
    "name": "last_updated_time",
    "chineseName": "最后更新时间",
    "metric": "应用最后一次更新的时间",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 41,
    "name": "title",
    "chineseName": "标题",
    "metric": "应用相关的舆情文章的标题",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 42,
    "name": "comment_content",
    "chineseName": "评论内容",
    "metric": "应用相关舆情文章的用户评论或反馈",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 43,
    "name": "link",
    "chineseName": "链接",
    "metric": "指向舆情信息原始来源的网址链接",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 44,
    "name": "source_website",
    "chineseName": "来源网站",
    "metric": "应用相关舆情文章最初发布的网站名称或域名",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 45,
    "name": "publish_date",
    "chineseName": "日期",
    "metric": "应用相关舆情文章发布或更新的日期和时间",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 46,
    "name": "media_type",
    "chineseName": "媒体类型",
    "metric": "发布应用相关舆情文章的媒体类型",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 47,
    "name": "original_author",
    "chineseName": "原文作者",
    "metric": "撰写应用相关舆情文章的作者姓名或昵称",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 48,
    "name": "info_attribute",
    "chineseName": "信息属性",
    "metric": "应用相关舆情文章的特定属性或分类标签，如正面、负面、中性等情感倾向",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 49,
    "name": "summary",
    "chineseName": "摘要",
    "metric": "对应用相关舆情文章内容的简短总结或概述",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 50,
    "name": "similar_article_count",
    "chineseName": "相似文章数",
    "metric": "与当前舆情信息内容相似或相关的其他文章数量",
    "frequency": "月",
    "range": "全国"
  }],
  "企业画像数据": [{
    "index": 1,
    "name": "cmpy_abbrev",
    "chineseName": "公司简称",
    "metric": "企业通常用于正式场合或日常交流中的简短名称",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 2,
    "name": "cmpy_full_nam",
    "chineseName": "公司全称",
    "metric": "企业的完整、正式注册名称",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 3,
    "name": "remarks_nam",
    "chineseName": "备注名",
    "metric": "内部或特定情境下使用的公司名称",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 4,
    "name": "cmpy_logo",
    "chineseName": "公司logo",
    "metric": "企业的视觉标识",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 5,
    "name": "cmpy_web",
    "chineseName": "公司网址",
    "metric": "企业的官方网站地址",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 6,
    "name": "ind",
    "chineseName": "行业",
    "metric": "企业所属的行业分类",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 7,
    "name": "intro",
    "chineseName": "一句话简介",
    "metric": "对企业核心业务或特点的精炼描述",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 8,
    "name": "cmpy_introduce",
    "chineseName": "公司介绍",
    "metric": "全面介绍企业的历史、愿景、使命、核心价值观、业务范围等信息",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 9,
    "name": "prod_and_srv",
    "chineseName": "产品及服务",
    "metric": "企业提供的具体产品或服务列表及详细描述",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 10,
    "name": "market_and_user",
    "chineseName": "市场及用户",
    "metric": "企业目标市场的定位、用户群体特征、需求分析等",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 11,
    "name": "busi_mdl",
    "chineseName": "商业模式",
    "metric": "企业如何创造价值、传递价值和获取价值的具体方式",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 12,
    "name": "optn_data",
    "chineseName": "运营数据",
    "metric": "反映企业运营状况的关键数据指标，如收入、用户量、活跃度等",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 13,
    "name": "core_res",
    "chineseName": "核心资源",
    "metric": "企业运营所依赖的关键资源，如技术、人才、品牌、资金等",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 14,
    "name": "label",
    "chineseName": "标签",
    "metric": "用于描述企业特征的关键词或短语，便于分类和搜索",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 15,
    "name": "optn_label",
    "chineseName": "运营标签",
    "metric": "针对企业运营状态的特定标签，如“初创”、“成长”、“成熟”等",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 16,
    "name": "receive_inv_rnd",
    "chineseName": "获投轮次",
    "metric": "企业获得外部投资的轮次，如天使轮、A轮、B轮等",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 17,
    "name": "optn_stat",
    "chineseName": "运营状态",
    "metric": "企业当前的运营状况，如“正常运营”、“暂停运营”、“已注销”等",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 18,
    "name": "cmpy_scale",
    "chineseName": "公司规模",
    "metric": "企业规模的量化描述，如员工人数、营业额等",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 19,
    "name": "est_dt",
    "chineseName": "成立日期",
    "metric": "企业正式成立的日期",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 20,
    "name": "office_addr",
    "chineseName": "办公地址",
    "metric": "企业的办公场所地址",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 21,
    "name": "city",
    "chineseName": "所在城市",
    "metric": "企业办公地址所在的城市",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 22,
    "name": "cmpy_tel",
    "chineseName": "公司电话",
    "metric": "企业的联系电话",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 23,
    "name": "cmpy_mail",
    "chineseName": "公司邮箱",
    "metric": "企业的官方邮箱地址",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 24,
    "name": "cmpy_wechat",
    "chineseName": "公司微信",
    "metric": "企业的官方微信公众号或微信账号",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 25,
    "name": "cmpy_weibo",
    "chineseName": "公司微博",
    "metric": "企业的官方微博账号",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 26,
    "name": "prod_id",
    "chineseName": "产品ID",
    "metric": "用于唯一标识企业产品的编号",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 27,
    "name": "prod_nam",
    "chineseName": "产品名称",
    "metric": "企业产品的正式名称",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 28,
    "name": "whether_main_prod",
    "chineseName": "是否主产品",
    "metric": "标识该产品是否为企业的主打产品或核心产品",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 29,
    "name": "prod_desc",
    "chineseName": "产品描述",
    "metric": "对产品功能、特点、优势的详细描述",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 30,
    "name": "prod_link",
    "chineseName": "产品链接",
    "metric": "产品的通用访问链接",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 31,
    "name": "ios_link",
    "chineseName": "IOS链接",
    "metric": "产品的iOS系统下载或访问链接",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 32,
    "name": "android_link",
    "chineseName": "安卓链接",
    "metric": "产品的安卓系统下载或访问链接",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 33,
    "name": "prod_wechat",
    "chineseName": "产品微信",
    "metric": "产品的微信小程序或微信内访问路径",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 34,
    "name": "inv_event_id",
    "chineseName": "投资事件ID",
    "metric": "用于唯一标识企业融资事件的编号",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 35,
    "name": "receive_inv_cmpy_id",
    "chineseName": "获投公司ID",
    "metric": "被投资企业的唯一标识编号",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 36,
    "name": "receive_inv_cmpy_full_nam",
    "chineseName": "获投公司全称",
    "metric": "被投资企业的完整、正式注册名称",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 37,
    "name": "fs_rnd",
    "chineseName": "融资轮次",
    "metric": "企业融资的具体轮次",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 38,
    "name": "fs_time",
    "chineseName": "融资时间",
    "metric": "企业融资的具体时间",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 39,
    "name": "fs_amt",
    "chineseName": "融资金额",
    "metric": "企业融资的金额",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 40,
    "name": "fs_ccy",
    "chineseName": "融资币种",
    "metric": "融资所使用的货币种类",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 41,
    "name": "inv_abbrev",
    "chineseName": "投资方简称",
    "metric": "投资方的简短名称",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 42,
    "name": "inv_full_nam",
    "chineseName": "投资方全称",
    "metric": "投资方的完整、正式名称",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 43,
    "name": "comp_prods_id",
    "chineseName": "竞品ID",
    "metric": "竞争对手或类似产品的唯一标识编号",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 44,
    "name": "comp_prods_cmpy_abbrev",
    "chineseName": "竞品公司简称",
    "metric": "竞争对手或类似产品的简短名称",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 45,
    "name": "comp_prods_cmpy_full_nam",
    "chineseName": "竞品公司全称",
    "metric": "竞争对手或类似产品的完整、正式名称",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 46,
    "name": "comp_prods_cmpy_logo",
    "chineseName": "竞品公司logo",
    "metric": "竞争对手或类似产品的视觉标识",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 47,
    "name": "comp_prods_cmpy_rnd",
    "chineseName": "竞品公司轮次",
    "metric": "竞争对手或类似产品的融资轮次",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 48,
    "name": "comp_prods_cmpy_ind",
    "chineseName": "竞品公司行业",
    "metric": "竞争对手或类似产品所属的行业分类",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 49,
    "name": "comp_prods_comp_prof",
    "chineseName": "竞品公司一句话简介",
    "metric": "对竞争对手或类似产品核心特点的精炼描述",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 50,
    "name": "comp_prods_cmpy_city",
    "chineseName": "竞品公司所在城市",
    "metric": "竞争对手或类似产品所在的城市",
    "frequency": "月",
    "range": "全国"
  }],
  "汽车制造数据": [{
    "index": 1.0,
    "name": "level_1_brand_id",
    "chineseName": "一级品牌ID",
    "metric": "用于唯一标识汽车品牌中的最高级别分类的编号",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 2.0,
    "name": "level_1_brand_name",
    "chineseName": "一级品牌名称",
    "metric": "汽车品牌中的最高级别分类的名称",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 3.0,
    "name": "level_2_brand_id",
    "chineseName": "二级品牌ID",
    "metric": "在一级品牌下进一步细分的品牌或系列的唯一标识编号。有些品牌可能不使用二级品牌，直接归于一级品牌下",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 4.0,
    "name": "level_2_brand_name",
    "chineseName": "二级品牌名称",
    "metric": "在一级品牌下进一步细分的品牌或系列的名称",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 5.0,
    "name": "series_id",
    "chineseName": "车系ID",
    "metric": "用于唯一标识某个品牌下的具体车系的编号",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 6.0,
    "name": "series_name",
    "chineseName": "车系名称",
    "metric": "具体车系的名称",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 7.0,
    "name": "sales_model_id",
    "chineseName": "销售车型ID",
    "metric": "用于唯一标识某车系下具体销售车型的编号",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 8.0,
    "name": "sales_model_name",
    "chineseName": "销售车型名称",
    "metric": "具体销售车型的名称",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 9.0,
    "name": "year_model",
    "chineseName": "年款",
    "metric": "车型发布的年份",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 10.0,
    "name": "vehicle_type_category",
    "chineseName": "车型大类",
    "metric": "对车型进行的粗略分类",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 11.0,
    "name": "primary_classification_of_vehicle_type",
    "chineseName": "车型一级分类",
    "metric": "在车型大类下的进一步细分，如轿车中的紧凑型车、中型车等",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 12.0,
    "name": "secondary_classification_of_vehicle_type",
    "chineseName": "车型二级分类",
    "metric": "基于市场定位在车型一级分类下的再细分",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 13.0,
    "name": "manufacturer",
    "a": "s_suggested_retail_price(msrp)",
    "chineseName": "车辆厂商指导价",
    "metric": "汽车制造商公布的官方建议零售价格",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 14.0,
    "name": "new_car_market_price",
    "chineseName": "新车市场价",
    "metric": "新车在市场上实际销售的价格",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 15.0,
    "name": "displacement_(l)",
    "chineseName": "排量(L)",
    "metric": "发动机排量的度量，单位为升",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 16.0,
    "name": "power_type",
    "chineseName": "动力类型",
    "metric": "车辆的动力来源，如汽油、柴油、混合动力、纯电动等",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 17.0,
    "name": "number_of_seats",
    "chineseName": "座位数",
    "metric": "车辆内提供的座位数量",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 18.0,
    "name": "body_structure",
    "chineseName": "车身结构",
    "metric": "车辆的整体结构类型",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 19.0,
    "name": "intake_form",
    "chineseName": "进气形式",
    "metric": "发动机进气的方式，如自然吸气、涡轮增压等",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 20.0,
    "name": "drive_form",
    "chineseName": "驱动形式",
    "metric": "车辆的驱动方式，如前驱、后驱、四驱等",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 21.0,
    "name": "fuel_injection_form",
    "chineseName": "燃油喷射形式",
    "metric": "燃油进入发动机的方式，如多点电喷、直喷等",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 22.0,
    "name": "country_of_origin",
    "chineseName": "国别名称",
    "metric": "车辆制造国家的名称",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 23.0,
    "name": "launch_year",
    "chineseName": "上市年份",
    "metric": "车型正式上市的年份",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 24.0,
    "name": "out-of-production_date",
    "chineseName": "停产日期",
    "metric": "车型停止生产的日期，如果仍在生产则为空",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 25.0,
    "name": "configuration_grade",
    "chineseName": "配置等级",
    "metric": "车型内部配置的高低等级划分",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 26.0,
    "name": "external_dimensions_/lengthwidthheight",
    "chineseName": "外形尺寸/长*宽*高(mm)",
    "metric": "车辆的外形尺寸，以毫米为单位，包括长度、宽度和高度",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 27.0,
    "name": "front_track",
    "chineseName": "前轮距(mm)",
    "metric": "车辆前轮中心线之间的距离，以毫米为单位",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 28.0,
    "name": "rear_track",
    "chineseName": "后轮距(mm)",
    "metric": "车辆后轮中心线之间的距离，以毫米为单位",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 29.0,
    "name": "wheelbase",
    "chineseName": "轴距(mm)",
    "metric": "车辆前后轴之间的距离，以毫米为单位",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 30.0,
    "name": "curb_weight(kg)",
    "chineseName": "整备质量(kg)",
    "metric": "车辆装备齐全，加满油、水时的质量，以千克为单位",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 31.0,
    "name": "number_of_doors",
    "chineseName": "车门数",
    "metric": "车辆的车门数量",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 32.0,
    "name": "engine_type",
    "chineseName": "发动机类型",
    "metric": "发动机的具体类型，如直列四缸、V型六缸等",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 33.0,
    "name": "engine_description",
    "chineseName": "发动机描述",
    "metric": "对发动机性能的详细描述，如最大功率、最大扭矩等",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 34.0,
    "name": "fuel_rating",
    "chineseName": "燃油标号",
    "metric": "车辆应使用的燃油标号，如92号、95号汽油",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 35.0,
    "name": "emission_standard",
    "chineseName": "排放标准",
    "metric": "车辆排放废气的标准，如国五、国六等",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 36.0,
    "name": "power_output",
    "chineseName": "功率",
    "metric": "发动机的最大功率",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 37.0,
    "name": "gearbox_gears",
    "chineseName": "变速器档数(个)",
    "metric": "变速器提供的档位数量",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 38.0,
    "name": "transmission_type",
    "chineseName": "变速器类型",
    "metric": "变速器的具体类型，如手动变速器、自动变速器（AT、CVT、DCT等）",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 39.0,
    "name": "front_tire_specifications",
    "chineseName": "前轮胎规格",
    "metric": "前轮胎的尺寸和类型规格",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 40.0,
    "name": "rear_tire_specifications",
    "chineseName": "后轮胎规格",
    "metric": "后轮胎的尺寸和类型规格",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 41.0,
    "name": "abs_identification",
    "chineseName": "ABS标识",
    "metric": "是否配备防抱死制动系统（ABS）的标识",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 42.0,
    "name": "cylinder_arrangement",
    "chineseName": "气缸排列形式",
    "metric": "发动机气缸的排列方式，如直列、V型等",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 43.0,
    "name": "number_of_engine_valves",
    "chineseName": "发动机气门数(个)",
    "metric": "发动机的气门数量",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 44.0,
    "name": "domestic/imported",
    "chineseName": "国产/进口",
    "metric": "车辆是国产还是进口的分类",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 45.0,
    "name": "vin_code_production_year",
    "chineseName": "VIN码出厂年份",
    "metric": "通过车辆识别码（VIN码）解析出的车辆出厂年份",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 46.0,
    "name": "chassis_number",
    "chineseName": "底盘号",
    "metric": "车辆的底盘识别号",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 47.0,
    "name": "group_id",
    "chineseName": "车组ID",
    "metric": "用于组织或分类相似车型、配置的编号",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 48.0,
    "name": "group_name",
    "chineseName": "车组名称",
    "metric": "对应车组的名称",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 49.0,
    "name": "body_color",
    "chineseName": "车身颜色",
    "metric": "车辆车身的颜色",
    "frequency": "月",
    "range": "全国"
  }, {
    "index": 50.0,
    "name": "time_to_market",
    "chineseName": "上市时间",
    "metric": "车型正式面向市场销售的日期",
    "frequency": "月",
    "range": "全国"
  }]
};